import { Component, h, Prop } from '@stencil/core';
// import { Watch, Element } from '@stencil/core';
import '../../../stories/Components/Head/Head';
import { ConversationDetails } from '../../../types/ConversationDetailsTypes';

@Component({
  tag: 'chat-header',
  shadow: true,
})
class ChatHeader {
  @Prop() conversationDetails: ConversationDetails;
  @Prop() onMinimize: () => void;
  @Prop() onClose: () => void;
  @Prop() isTyping: boolean;
  @Prop() backgroundColor?: string;
  @Prop() isDark?: boolean;

  render() {
    return (
      <my-head
        profileImage={this.conversationDetails?.opponentDetails?.userProfileImageUrl}
        onFirstSvgClick={this.onMinimize}
        onSecondSvgClick={this.onClose}
        text={this.conversationDetails?.opponentDetails?.userName}
        borderRadius="8px 8px 0 0"
        padding="20px 15px 20px 15px"
        lastSeenText={this.isTyping ? 'Typing...' : ''}
        lastSeenTextColor="#FFF"
        bgColor={'var(--chat-header-bg)'}
        textColor={'var(--chat-header-text)'}
        nameTextColor= {'var(--chat-header-name-text)'}
        closeIconColor= {'var(--chat-header-close-icon)'}
        minimizeIconColor = {'var(--chat-header-minimize-icon)'}
      />
    );
  }
}

export { ChatHeader };

